import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useReportForm } from 'modules/reports/hooks/useReportFormContext';
import { StepNumber } from 'types/stepper/stepper.type';

const useStepLogic = (currentStep: StepNumber) => {
  const { formData } = useReportForm();
  const navigate = useNavigate();

  const isStepDisabled = (step: StepNumber): boolean => {
    if (step > 2) return true;

    if (step === 2 && formData.clients.length === 0) {
      return true;
    }

    return false;
  };

  useEffect(() => {
    if (currentStep === 2 && formData.clients.length === 0) {
      navigate('/reports/new/select-clients');
    }
  }, [currentStep, formData.clients.length, navigate]);

  return { isStepDisabled };
};

export default useStepLogic;
